var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTradingViewinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.22 2.043a2.043 2.043 0 11-4.086 0 2.043 2.043 0 014.087 0zM8.126.144H0v4.087h4.038v6.057h4.087V.144zm7.163 0H20l-4.255 10.144h-4.712L15.288.144z",
    fill: "#000"
  })));
}
export default SvgTradingViewinline;